module.exports = __webpack_public_path__ + "img/grey.017abaaf.webp";